<template>
    <Layout>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Registration Update Completed</h2>
                            <p>You have successfully updated your application. You will receive an email shortly acknowledging your application.
                                We look forward to welcoming you to the conference.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required } from 'vuelidate/lib/validators'
import Api from '@/Api'

export default {
    name: 'ThankAfterRegistration',
    components: {Layout},
    data() {
        return {
            conference: JSON.parse(localStorage.getItem('conference'))
        };
    },
    validations: {

    },
    methods: {

    }
};
</script>
